import { render, staticRenderFns } from "./together-number.vue?vue&type=template&id=9b535a8c&scoped=true"
import script from "./together-number.vue?vue&type=script&lang=js"
export * from "./together-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b535a8c",
  null
  
)

export default component.exports